import { Box, Drawer } from "@mui/material";
import SideBarContent from "./SideBarContent";
import { FC } from "react";

const MobileSideBar: FC<{
  handleUserManual: () => void;
  closeMobileSideBar: any;
  showMobileSideBar: any;
  isRightUser: any;
}> = ({
  closeMobileSideBar,
  showMobileSideBar,
  handleUserManual,
  isRightUser,
}) => {
  return (
    <Drawer
      anchor="left"
      open={showMobileSideBar}
      onClose={closeMobileSideBar}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "300px",
          backgroundColor: "#fff",
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ height: "85vh" }}>
          <SideBarContent closeMobileSideBar={closeMobileSideBar} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default MobileSideBar;
